var React = require('react');
var Link = require('react-router').Link;
var Router = require('react-router');

var logo = require('../../images/infinite-logo-web-hi-res.png');

var Timeout = React.createClass({
    contextTypes: {
        router: React.PropTypes.func.isRequired
    },
    render: function () {
        var activeRoutes = this.context.router.getCurrentRoutes();
        var params = this.context.router.getCurrentParams();
        var query = this.context.router.getCurrentQuery();
        var route = activeRoutes[activeRoutes.length - 1].name;
        return <div className="colorful-page-wrapper">
          <div className="center-block">
            <div className="login-block">
                <header>
                  <div className="image-block"><img src={logo} alt="User" /></div>
                  Timeout
                </header>
                <fieldset><p>Your session has timed out.</p></fieldset>
                <fieldset><p><Link to="login" query={{route: route, args: params, query: query}}>Login again</Link></p></fieldset>
                <footer></footer>
            </div>
          </div>
        </div>;
    }
})
module.exports = Timeout;



// WEBPACK FOOTER //
// ./app/components/Authentication/Timeout.js